<template>
  <div class="input">
    <div class="input-label">絵柄</div>
    <div class="input-group">
      <input-select
        :option="suit"
        :options="$store.getters['option/suits']"
        @select="(o) => suit = o" />
    </div>
  </div>
</template>


<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect
  },

  computed: {
    suit: {
      get: function () {
        return this.$store.state.quiz.suit
      },

      set: function (value) {
        this.$store.commit(
          'quiz/setSuit',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
